import { useAppDispatch, useAppSelector } from '@/hooks/redux'
import { screenSelectors, setScreen } from '@/redux/reducers/screen'
import { useEffect } from 'react'
import { Dimensions, ScaledSize } from 'react-native'

export const useScreenListener = (): void => {
    const dispatch = useAppDispatch()

    useEffect(() => {
        const onChange = ({ window }: { window: ScaledSize }) => {
            dispatch(setScreen(window))
        }

        const onChangeListener = Dimensions.addEventListener('change', onChange)

        return () => onChangeListener.remove()
    }, [dispatch])
}

export const useScreenOrientation = () => useAppSelector(screenSelectors.orientation)
export const useScreenSize = () => useAppSelector(screenSelectors.size)
export const useScreenLayout = () => useAppSelector(screenSelectors.layout)
export const useScreenWidth = () => useAppSelector(screenSelectors.width)
